import { ROUTE_PATH as KKM_PATH } from '@/features/kkmsPage/consts';

export const createEditKkmLink = kkmId => `${KKM_PATH}/${kkmId}/edit`;
